export const ALERT_START = "ALERT_START"
export const ALERT_END = "ALERT_END"
export const LOADING_START = 'LOADING_START'
export const LOADING_END = 'LOADING_END'